import { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilledButton } from 'components';

import useSettingsModalStyles from './SettingsModal.styles';
import { shareContext } from '../../ShareContext';
import { useSelectedLinkContext } from 'contexts';
import { settingsContext } from './SettingsContext';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import MobileExplorerToolbarMenuItemButton from 'mobile/App/Share/ExplorerToolbar/MobileExplorerToolbarMenuItemButton';

type DeleteOrQuitFolderButtonPureProps = {
  labelId: string;
  handleClick: () => void;
};

const DeleteOrQuitFolderButtonPure = ({
  labelId,
  handleClick,
}: DeleteOrQuitFolderButtonPureProps): JSX.Element => {
  const settingsModalClasses = useSettingsModalStyles();

  return (
    <FilledButton
      className={settingsModalClasses.button}
      color="violet"
      data-testid="delete-or-quit-folder-button"
      onClick={handleClick}
    >
      <FormattedMessage id={labelId} />
    </FilledButton>
  );
};

const getLabelId = (isFolderAdmin: boolean) =>
  isFolderAdmin
    ? 'share.folder.settings.deleteFolder'
    : 'share.folder.settings.quitFolder';

const DeleteOrQuitFolderButton = (): JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();
  const { selectedFolder } = useContext(shareContext);
  const isFolderAdmin = selectedFolder?.creator === selectedLink?.userKey;
  const { setShowDeleteOrQuitModal, setShowSettingsModal } =
    useContext(settingsContext);
  const isSmallScreen = useSmallDesktopScreen();

  const handleClick = useCallback(() => {
    setShowSettingsModal(false);
    setShowDeleteOrQuitModal(true);
  }, [setShowDeleteOrQuitModal, setShowSettingsModal]);

  const labelId = getLabelId(isFolderAdmin);

  if (isSmallScreen) {
    return (
      <MobileExplorerToolbarMenuItemButton
        messageId={labelId}
        onClick={handleClick}
      />
    );
  }

  return (
    <DeleteOrQuitFolderButtonPure labelId={labelId} handleClick={handleClick} />
  );
};

export default DeleteOrQuitFolderButton;
